import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { handleError, handleSuccess } from '../utils';
import { ToastContainer } from 'react-toastify';
import '../App.css';

function Home() {

  const navigate = useNavigate()
  const [loggedInUser, setLoggedInUser]= useState('');
  useEffect(()=>{
    setLoggedInUser(localStorage.getItem('loggedInUser'))
  },[]);
  const [products, setProducts] = useState([]);


  const fetchProducts = async ()=>{
    try{
      const baseUrl = process.env.REACT_APP_BACKEND_URL;
      const url = `${baseUrl}/products`;
      const token = localStorage.getItem('token')
      const headers = { 
        headers: {
          "Authorization": token,
          "Content-Type": "application/json"
        }
      }
      const res = await fetch(url, headers)
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`)
      }
      const data = await res.json()
      console.log('Products data:', data)
      setProducts(data)
    }catch(err){
      handleError(err)
    }
  }
  useEffect(()=>{
    fetchProducts()
  },[])
  
  const handleLogout = (e) => {
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    handleSuccess('User Logged Out Successfully');
    setTimeout(() => {
      navigate('/login');
    }, 2000);
  };

  return (
    <>
      {/* Top Navigation Bar */}
      <nav className="top-navbar">
        <div className="nav-content">
          <div className="nav-left">
            <div className="nav-brand">
              <img src="/favicon.png" alt="AuthApp Logo" className="nav-logo" />
              <h1 className="nav-title">AuthApp</h1>
            </div>
            <span className="welcome-text">Welcome{loggedInUser ? `, ${loggedInUser}` : ''}!</span>
          </div>
          <div className="nav-right">
            <button className="btn btn-logout" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="main-container">
        <div className="content-wrapper">
          <div className="products-section">
            <h2 className="section-title">Available Products</h2>
            {products.length > 0 ? (
              <div className="products-grid">
                {products.map((item, index) => (
                  <div key={index} className="product-card">
                    <div className="product-image-container">
                      <img src={item.image} alt={item.product} className="product-card-image" />
                    </div>
                    <div className="product-card-content">
                      <h3 className="product-card-title">{item.product}</h3>
                      <p className="product-card-price">${item.price}</p>
                      <button className="btn btn-view-details">View Details</button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-text">Loading products...</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  )
}

export default Home